import {makeStyles} from '@material-ui/core';
import {alpha} from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles(theme => ({
    actionButton: {
        minWidth: '140px',
        backgroundColor: alpha(theme.palette.background.default, 0.72)
    },
    alertSkeletonButton: {
        width: '140px!important',
        [theme.breakpoints.down('xs')]: {
            width: '100%!important'
        }
    },
    alertSkeleton: {
        marginTop: '15px',
        // @ts-ignore:next-line
        backgroundColor: theme.palette.background.overlays,
        padding: '4px 10px',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            '& .MuiAlert-action, & .MuiSkeleton-root': {
                width: '100%'
            },
            '& .MuiAlert-icon': {
                display: 'flex',
                minWidth: '16px',
                width: '16px'
            },
            '& .MuiAlert-message': {
                padding: '6px 0 6px 11px',
                width: 'calc(100% - 16px)'
            }
        }
    },
    alert: {
        marginTop: '15px',
        alignItems: 'center',
        // @ts-ignore:next-line
        backgroundColor: theme.palette.background.overlays,
        paddingTop: '14px',
        paddingBottom: '14px',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            '& .MuiAlert-action': {
                marginTop: '12px'
            },
            '& .MuiAlert-action, & .MuiButtonBase-root': {
                width: '100%'
            },
            '& .MuiAlert-icon': {
                display: 'flex',
                minWidth: '16px',
                width: '16px'
            },
            '& .MuiAlert-message': {
                padding: '0 11px',
                width: 'calc(100% - 16px)'
            }
        }
    },
    alertMessage: {
        fontWeight: 'bold'
    }
}));

export default useStyles;
